/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import jwtDecode from 'jwt-decode';
import { GetMySubscriptionPages } from './API';
import AppRouter from './components/AppRouter/AppRouter';
import { appConfig } from './config/appConfig';
import Spiner from './components/Spiner';
import { getAccessToken } from './helpers/token';

const SubscriptionProvider: React.FC = () => {
  const token = getAccessToken();

  const decodedToken: any = token ? jwtDecode(token) : null;
  const isAdmin =
    decodedToken?.[
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
    ]?.includes('@cucollaborate.com') || false;

  const [hasAccess, setHasAccess] = useState(isAdmin);

  const { data, isSuccess, isLoading, isError } = useQuery({
    ...GetMySubscriptionPages(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    useErrorBoundary: false,
    enabled: !isAdmin,
  });

  // Check for subscription
  useEffect(() => {
    if (!isSuccess || !data) return;

    const hasSubscription = data.some(
      (x) => (x.endsWith('/') ? x.slice(0, -1) : x) === appConfig.productPageUrl
    ); // Ignore last '/' in data URLs

    if (hasSubscription) {
      setHasAccess(() => true);
    } else {
      window.location.href = appConfig.paywallRedirectUrl;
    }
  }, [data, isSuccess]);

  if (isLoading)
    return (
      <div className="centered-content">
        <Spiner />
      </div>
    );
  if (isError)
    return (
      <div className="centered-content">
        Something went wrong, please try again
      </div>
    );

  return hasAccess ? <AppRouter /> : null;
};

export default SubscriptionProvider;
